import { render } from "./VideoBackground.vue?vue&type=template&id=3b43ed7d&scoped=true"
import script from "./VideoBackground.vue?vue&type=script&lang=js"
export * from "./VideoBackground.vue?vue&type=script&lang=js"

import "./VideoBackground.vue?vue&type=style&index=0&id=3b43ed7d&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1444689866/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b43ed7d"]])

export default __exports__